import { IconTrash } from "@tabler/icons-react"
import { createColumnHelper } from "@tanstack/react-table"
import { ActionIcon, TextCell } from "@tfg/ui"
import { useMemo } from "react"
import { queryClient } from "~/backend/queryClient"

import {
  findAllActivitiesQueryKey,
  FindAllActivitiesResponseDto,
  useDeleteActivity,
} from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

const columnHelper = createColumnHelper<FindAllActivitiesResponseDto>()

export const useColumns = (activities: FindAllActivitiesResponseDto[]) => {
  const { mutate: deleteActivity } = useDeleteActivity({
    mutation: {
      onSuccess: async () => {
        showSuccessNotification({
          title: "Deleted",
          message: "Successfully deleted activity",
        })
        await queryClient.invalidateQueries({
          queryKey: findAllActivitiesQueryKey(),
        })
      },
      onError: (error) => {
        showAxiosError({
          defaultMessage: "Failed to delete activity",
          showNotification: true,
          error,
        })
      },
    },
  })

  return useMemo(
    () => [
      columnHelper.accessor("id", {
        header: "ID",
        cell: ({ getValue }) => <TextCell value={getValue()} />,
      }),
      columnHelper.accessor("name", {
        header: "Name",
        cell: ({ getValue }) => <TextCell value={getValue()} />,
      }),
      columnHelper.accessor((row) => row.id, {
        header: () => null,
        id: "action-cell-delete",
        enableSorting: false,
        cell: ({ row }) => (
          <ActionIcon
            icon={<IconTrash />}
            onClick={() =>
              deleteActivity({ data: { activityId: row.original.id } })
            }
          />
        ),
      }),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activities]
  )
}
